import ajax from '../utils/ajax'

export default {
    getByHash: (hash, code, anonId) => ajax.get("/api/loadingVessels/byHash", {params: {hash, code, anonId}}),
};
